












import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch, Prop } from 'vue-property-decorator'
import { formatToYYYYMMDD, getDateStingFromDate } from '@/utils/DateUtil'

@Component
export default class FechaSelect extends Vue {
  $refs: {
    test: Vue & { $el: HTMLElement }
  }
  @Prop({ required: false, type: String })
  private max: string | null
  @Prop({ required: false, type: String })
  private min: string | null

  @Prop({ type: Boolean, default: false })
  private autofocus: boolean

  @Prop({ type: Boolean, default: false })
  private disabled: boolean

  @Prop()
  private label: string

  @Prop({ required: false, type: String })
  private value: string | null | undefined

  @Prop({ required: false, type: Array })
  private rules: any[]

  @Prop({ default: false })
  private error: boolean

  @Prop({ required: false, type: Array })
  private errorMessages: string[]

  private today = new Date()

  // Modal del calendario
  private modal = false
  mounted() {
    // if (this.value) this.date = formatToYYYYMMDD(this.value)
  }
  // Fecha del calendario
  private date: string | null = null
  private getDateStingFromDate(date: Date) {
    if (date) {
      return getDateStingFromDate(date)
    } else {
      return null
    }
  }

  private get currentDateToShow() {
    if (this.value && this.value !== '') {
      return formatToYYYYMMDD(this.value)
    } else if (this.min) {
      return formatToYYYYMMDD(getDateStingFromDate(new Date(this.min)))
    } else {
      return formatToYYYYMMDD(getDateStingFromDate(new Date()))
    }
  }
  // fecha formateada
  private formatted = ''
  private formatToYYYYMMDD(date: string) {
    if (date) {
      return formatToYYYYMMDD(date)
    } else return null
  }
  @Watch('date')
  formatDate(date: string) {
    if (date) {
      const [year, month, day] = date.split('-')

      const fromatedDate = `${day}-${month}-${year}`
      this.$emit('input', fromatedDate)
    }
  }
}
